export default class Saga {
  static flank = "LR";
  static central = "C";
}
